import { Route } from '@angular/router';
import {
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { RedirectionGuard } from './guard/redirection.guard';

import { authorizationGuardFn } from '@infodata-group/inf-commons';

import { AccountGuard } from './guard/account.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [RedirectionGuard],
    children: [
      { path: 'login', component: PageLoginComponent },
      { path: 'reset-password', component: PagePwdResetComponent },
      { path: 'reset-request', component: PageResetRequestComponent },
      { path: 'oauth2', component: PageOauth2LandingComponent },
      {
        path: 'init',
        loadComponent: () =>
          import('./page/page-loading/page-loading.component').then(
            (m) => m.PageLoadingComponent,
          ),
      },
      {
        path: 'select-account',
        canActivate: [authorizationGuardFn],
        loadComponent: () =>
          import(
            './page/page-select-account/page-select-account.component'
          ).then((m) => m.PageSelectAccountComponent),
      },
      { path: '', redirectTo: 'init', pathMatch: 'full' },
      {
        path: 'main',
        loadComponent: () =>
          import('./page/page-main/page-main.component').then(
            (m) => m.PageMainComponent,
          ),
        canActivate: [authorizationGuardFn, AccountGuard],
        children: [
          { path: '', redirectTo: 'init', pathMatch: 'full' },
          {
            path: 'encoding',
            loadComponent: () =>
              import('./page/page-entry/page-entry.component').then(
                (m) => m.PageEntryComponent,
              ),
          },
          {
            path: 'encoding/:id',
            loadComponent: () =>
              import('./page/page-entry/page-entry.component').then(
                (m) => m.PageEntryComponent,
              ),
          },
          {
            path: 'history/:type',
            loadComponent: () =>
              import('./page/page-history/page-history.component').then(
                (m) => m.PageHistoryComponent,
              ),
          },
          {
            path: 'open-post/:type',
            loadComponent: () =>
              import('./page/page-open-post/page-open-post.component').then(
                (m) => m.PageOpenPostComponent,
              ),
          },
          {
            path: 'turnover/:type',
            loadComponent: () =>
              import('./page/page-turnover/page-turnover.component').then(
                (m) => m.PageTurnoverComponent,
              ),
          },
          {
            path: 'balance/:type',
            loadComponent: () =>
              import('./page/page-balance/page-balance.component').then(
                (m) => m.PageBalanceComponent,
              ),
          },
          {
            path: 'billing/entry',
            loadComponent: () =>
              import(
                './page/page-billing-entry/page-billing-entry.component'
              ).then((m) => m.PageBillingEntryComponent),
          },
          {
            path: 'billing/article',
            loadComponent: () =>
              import('./page/page-article/page-article.component').then(
                (m) => m.PageArticleComponent,
              ),
          },
          {
            path: 'third/:type',
            loadComponent: () =>
              import('./page/page-client/page-client.component').then(
                (m) => m.PageClientComponent,
              ),
          },
        ],
      },
    ],
  },
];
